import api from "../axiosInterceptor"

export default {
  namespaced: true,
  state: {
    loginError: null,
    logoutError: null,
  },
  getters: {
    getLoginError: state => state.loginError,
    getLogoutError: state => state.logoutError,
  },
  mutations: {
    setLoginError(state, error) {
      state.loginError = error;
    },
    setLogoutError(state, error) {
      state.logoutError = error;
    },
    clearLoginError(state) {
      state.loginError = null;
    },
    clearLogoutError(state) {
      state.logoutError = null;
    },
  },
  actions: {

    sendLoginRequest({ commit}, data) {
      commit("clearLoginError");
      commit("setErrors", {}, { root: true });
      return api
        .post("login", data)
        .then(response => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            localStorage.setItem("authToken", response.data.data.token);
            localStorage.removeItem("lastFilterId")
          }
          else if (response && response.data && response.data.message) {
            commit("setLoginError", response.data.message);
          }
          else {
            commit("setLoginError", "Error in login");
          }
          return response;
        })
        .catch(error => {
          if (error.response) {
            const errorMessage = error.response.data.error;
            commit("setLoginError", errorMessage);
          }
          else {
            const loginTimeoutMessage = error;
            commit("setLoginError", loginTimeoutMessage)
          }
        });
    },
    sendLogoutRequest({ commit, dispatch }) {
      commit("clearLogoutError");

      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        commit("tenantId/LOGOUT", undefined, { root: true });
        return Promise.resolve({
          data: { statusCode: 200, message: "User already logged out" }
        });
      }

      return api.post("logout", {})
        .then(response => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            commit("tenantId/LOGOUT", undefined, { root: true });
          } else if (response && response.data && response.data.message) {
            commit("setLogoutError", response.data.message);
          } else {
            commit("setLogoutError", "Error in logout");
          }
          return response;
        })
        .catch((error) => {
          commit("setLogoutError", error);
          dispatch("tenantId/logoutUser", null, { root: true });
        });
    },
  },
};